import axios from 'axios'

export default{
    namespaced: true,
    state: {
       academicYearId: null,
       formClassId: null, 
       endpoint: '',
    },
    getters: {
       getAcademicYearId (state) {
        return state.academicYearId
       },

       getFormClassId (state) {
        return state.formClassId
       },

       getEndpoint(state){
            return state.endpoint;
       }
    },
    mutations: {
        setAcademicYearId (state, value) {
            state.academicYearId = value
        },

        setFormClassId (state, value) {
            state.formClassId = value
        },

        setEndpoint(state, endpoint) {
            state.endpoint = endpoint;
        }
    },
    actions: {

        getMarkSheetTerms () {
            let url = '/api/mark-sheet-terms';
            return axios.get(url);
        },
        
        getReportCardTerms () {
            let url = '/api/report-card-terms';
            return axios.get(url);
        },

        getClassListYears () {
            const url = '/api/class-list-years';
            return axios.get(url);
        },

        downloadASR () {
            const url = '/api/asr';
            return axios({
                method: 'get',
                url: url,
                responseType: 'arraybuffer'
            })
        },

        downloadSpreadsheet ({ getters }) {
            const url = getters.getEndpoint;
            return axios({
                method: 'get',
                url: url,
                responseType: 'arraybuffer',
            })
        },

        getFormClassesList({ getters }) {
            const url = '/api/form-classes-list'            
            return axios.get(url, {
                params: {
                    'academic_year_id': getters.getAcademicYearId
                }
            });
        },
    }
}    